import "./App.css";
import { Routes, Route } from "react-router-dom";

import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import Features from "./components/Features/Features";
import Testimonials from "./components/Testimonials/Testimonials";
import Downloads from "./components/Downloads/Downloads";
import Footer from "./components/Footer/Footer";
import PrivacyPolicy from "./components/Privacy/Privacy";
import ContactForm from "./components/Contact/Contact";
import AccountDeletionForm from "./components/AccountDeletion/AccountDeletionForm";

function App() {
  return (
    <Routes>
      {/* ✅ Home Page (With Header + Footer) */}
      <Route
        path="/"
        element={
          <>
            <Header />
            <main>
              <Hero />
              <Features />
              <Testimonials />
              <Downloads />
            </main>
            <Footer />
          </>
        }
      />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route
        path="/contact-us"
        element={
          <>
            <Header />
            <main>
              <ContactForm />
            </main>
            <Footer />
          </>
        }
      />
      <Route
        path="/account-deletion"
        element={
          <>
            <Header />
            <main>
              <AccountDeletionForm />
            </main>
            <Footer />
          </>
        }
      />
    </Routes>
  );
}

export default App;
